import ControlCustomPanel, { ICollapsiblePanelProperties } from "components/controls/CustomPanel";

const CustomPanel: React.FunctionComponent<ICollapsiblePanelProperties> = (props) => {
    return <ControlCustomPanel
        {...props}
        contentStyle={{ paddingTop: '10px', paddingBottom: '10px' }}
    />
}

export default CustomPanel;